import { isPast, isToday } from 'date-fns';

const isDayInThePast = (day: Date) =>
  !isToday(day) &&
  isPast(new Date(day.getFullYear(), day.getMonth(), day.getDate()));

export { isDayInThePast };
